import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentNumberCannotBeEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-number.is-empty');
    }
}
